


































































import { Component, Vue } from 'vue-property-decorator';
import { Table } from 'element-ui';
import ActionBar from './components/ActionBar.vue';
import { IUserProfile } from '@/shared/models';
import { requiredOnChange } from '@/shared/validation/rule';

export enum EUserType {
  Active,
  Inactive,
}
@Component({
  name: 'Users',
  components: {
    ActionBar,
  },
})
export default class Users extends Vue {
  EUserType = EUserType;

  userType: EUserType = EUserType.Active;

  isLoading = false;

  selectedUserId: number | null = null;

  filterQuery = {
    email: '',
    phone: '',
  };

  filterRules = {
    email: [requiredOnChange],
    phone: [requiredOnChange],
  };

  public listUser: IUserProfile[] = [];

  protected created() {
    this.fetch();
  }

  protected handleCurrentChange(val: IUserProfile) {
    this.selectedUserId = val ? val.id : null;
  }

  protected clearSelect() {
    if (this.$refs.userTable) (this.$refs.userTable as Table).setCurrentRow(undefined);
  }

  private async fetch() {
    this.clearSelect();
    this.isLoading = true;
    this.listUser = await this.$api.users.getListUser();
    this.isLoading = false;
  }
}
